import { render } from "./Foot.vue?vue&type=template&id=82abe6e0&scoped=true"
import script from "./Foot.vue?vue&type=script&lang=js"
export * from "./Foot.vue?vue&type=script&lang=js"

import "./Foot.vue?vue&type=style&index=0&id=82abe6e0&scoped=true&lang=scss"

import exportComponent from "/Users/phq/work/web/sy-website-master_s/template5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82abe6e0"]])

export default __exports__